/* Confirmation owns consent. Cart receives a single-use approved snapshot,
 * never the mutable configurator state. NB.cart.add is supplied in Part 3.
 */
(function () {
  'use strict';
  const NB = window.NB = window.NB || {};

  function init(root) {
    root = root?.matches?.('[data-section-type="confirm-modal"]')
      ? root : document.getElementById('confirm-modal');
    if (!root || root.__mergedConfirm) return;
    root.__mergedConfirm = true;

    const U = NB.util;
    const q = selector => root.querySelector(selector);
    const abort = new AbortController();
    const on = (target, event, handler) =>
      target.addEventListener(event, handler, { signal: abort.signal });
    const checkbox = q('[data-spelling-consent]');
    const add = q('[data-confirm-add]');
    const error = q('[data-confirm-error]');
    const status = q('[data-confirm-font-status]');
    const bracelet = NB.createProductPreview(q('[data-confirm-preview]'), {
      shine: false
    });
    const pairPreview = q('[data-confirm-pair-preview]') ? NB.createProductPreview(q('[data-confirm-pair-preview]'), {shine:false}) : null;
    let candidate = null;
    let revision = null;
    let loading = false;
    let fontReady = false;
    let busy = false;
    let generation = 0;
    let opener = null;
    let previousOverflow = null;

    const el = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    function showError(message) {
      error.textContent = message || '';
      error.hidden = !message;
    }

    function syncButton() {
      add.disabled = !root.open || !candidate || !checkbox.checked
        || loading || !fontReady || busy
        || revision !== NB.approval.revision();
      checkbox.disabled = busy || !candidate;
    }

    function unlockPage() {
      if (previousOverflow !== null) {
        if (previousOverflow.value) {
          document.documentElement.style.setProperty(
            'overflow', previousOverflow.value, previousOverflow.priority
          );
        } else {
          document.documentElement.style.removeProperty('overflow');
        }
        previousOverflow = null;
      }
    }

    function reset() {
      generation++;
      candidate = null;
      revision = null;
      loading = false;
      fontReady = false;
      busy = false;
      checkbox.checked = false;
      syncButton();
    }

    function close({ edit = false } = {}) {
      if (root.open) root.close();
      reset();
      unlockPage();
      if (edit) {
        document.dispatchEvent(new CustomEvent('nb:edit-names'));
      } else if (opener?.isConnected) {
        opener.focus({ preventScroll: true });
      }
    }

    function renderNames(item) {
      const list = q('[data-confirm-names]');
      list.replaceChildren();
      item.names.forEach((name, index) => {
        const row = el('li', 'merged-confirm__name');
        row.dataset.confirmName = String(index);
        row.append(
          el('small', '', item.product === 'pair' ? window.CariamText("copy.text_258", "ブレスレット[v0]の名前", {v0: index + 1}) : window.CariamText("copy.text_275", "名前 [v0]・表示順 [v1]", {v0: index + 1, v1: index + 1})),
          el('strong', 'merged-confirm__exact', name)
        );
        const tiles = el('div', 'merged-letter-tiles');
        tiles.setAttribute('aria-hidden', 'true');
        Array.from(name).forEach(letter => {
          tiles.append(el('span', '', letter));
        });
        const spelling = el('p', 'merged-spelling',
          Array.from(name).join(' · '));
        spelling.dataset.spelling = String(index);
        spelling.setAttribute('aria-label',
          window.CariamText("copy.text_278", "名前 [v0]・入力どおり：[v1]", {v0: index + 1, v1: Array.from(name).map(letter =>
            `${letter === letter.toUpperCase() ? window.CariamText("copy.text_276", '大文字') : window.CariamText("copy.text_277", '小文字')} ${letter}`
          ).join(', ')}));
        row.append(tiles, spelling);
        const warning = U.caseWarning(name);
        if (warning) {
          row.append(el('p', 'merged-help',
            window.CariamText("copy.text_279", "[v0]・入力どおりです。", {v0: warning})));
        }
        list.append(row);
      });
    }

    function renderMeta(item) {
      const grid = q('[data-confirm-meta]');
      grid.replaceChildren();
      [
        [window.CariamText("copy.text_032", '名前の数'), String(item.count)],
        [window.CariamText("copy.text_066", 'カラー'), U.colorLabel(item.color)],
        [window.CariamText("copy.text_280", '書体'), U.fontById(item.font).label],
        [window.CariamText("copy.text_281", '価格'), NB.shopify.current.money()]
      ].forEach(([label, value]) => {
        const cell = el('div');
        cell.append(el('dt', '', label), el('dd', '', value));
        grid.append(cell);
      });
    }

    async function open(source, expectedRevision = NB.approval.revision()) {
      if (root.open) close();
      reset();
      showError('');
      // Validates case, count, font, color and current config pricing; both the
      // object and names array are frozen. No consent timestamp exists yet.
      candidate = U.snapshot(source);
      revision = expectedRevision;
      if (revision !== NB.approval.revision()) {
        reset();
        throw new Error(window.CariamText("copy.text_252", 'デザインが変わりました。もう一度確認してください。'));
      }
      opener = document.activeElement;
      renderNames(candidate);
      renderMeta(candidate);
      bracelet.render(candidate);
      pairPreview?.render(candidate);
      checkbox.checked = false;
      loading = true;
      fontReady = false;
      status.textContent = window.CariamText("copy.text_282", '確認用の書体を読み込んでいます…');

      previousOverflow = {
        value: document.documentElement.style.getPropertyValue('overflow'),
        priority: document.documentElement.style.getPropertyPriority('overflow')
      };
      try {
        root.showModal();
        document.documentElement.style.setProperty('overflow', 'hidden');
      } catch (failure) {
        reset();
        unlockPage();
        throw failure;
      }
      q('#confirm-title').focus();
      syncButton();

      const request = ++generation;
      const ok = await NB.fonts.ensure(U.fontById(candidate.font));
      if (request !== generation || !candidate || !root.open) return;
      loading = false;
      fontReady = ok;
      status.textContent = ok
        ? window.CariamText("copy.text_283", '参考書体を読み込みました。一文字ずつ綴りを確認してください。')
        : window.CariamText("copy.text_284", '書体を読み込めません。閉じて接続を確認し、もう一度お試しください。');
      if (ok) bracelet.render(candidate);
      syncButton();
    }

    on(checkbox, 'change', syncButton);
    on(q('[data-confirm-edit]'), 'click', () => close({ edit: true }));
    on(q('[data-confirm-close]'), 'click', () => close());

    on(root, 'cancel', event => {
      event.preventDefault();
      close();
    });

    on(root, 'close', () => {
      reset();
      unlockPage();
    });

    on(document, 'nb:configuration-edited', () => {
      if (!candidate) return;
      generation++;
      candidate = null;
      revision = null;
      checkbox.checked = false;
      loading = false;
      fontReady = false;
      showError(window.CariamText("copy.text_285", 'デザインが変わりました。「名前を編集する」からやり直してください。'));
      syncButton();
    });

    on(add, 'click', () => {
      // Button disabling is presentation; all conditions are enforced here.
      if (busy) return;
      try {
        if (!root.open || !candidate || !checkbox.checked
            || loading || !fontReady
            || revision !== NB.approval.revision()) {
          throw new Error(window.CariamText("copy.text_286", '現在の名前を確認して、チェックを入れてください。'));
        }
        if (!NB.cart || typeof NB.cart.add !== 'function') {
          throw new Error(window.CariamText("copy.text_287", 'カートの準備ができていません。もう一度お試しください。'));
        }
        const current = NB.configurator?.getState();
        if (!current || U.signature(current) !== U.signature(candidate)) {
          NB.approval.invalidate();
          throw new Error(window.CariamText("copy.text_252", 'デザインが変わりました。もう一度確認してください。'));
        }

        busy = true;
        syncButton();
        showError('');

        // Only here, after the explicit checkbox check, do we stamp consent.
        // issue() creates a second deeply frozen, validated snapshot and a
        // one-use capability. Part 3's synchronous cart.add must assert it,
        // persist successfully, and consume it before returning.
        const approved = NB.approval.issue(candidate, revision);
        try {
          NB.cart.add(approved, {replaceId: NB.configurator.editId});
        } catch (failure) {
          // Revoke even if storage failed; another attempt needs fresh consent.
          NB.approval.invalidate();
          throw failure;
        }

        close();
        document.dispatchEvent(new CustomEvent('nb:added-to-cart', {
          detail: approved
        }));
      } catch (failure) {
        busy = false;
        checkbox.checked = false;
        showError(failure.message || window.CariamText("copy.text_288", 'カートに追加できませんでした。'));
        syncButton();
      }
    });

    const api = {
      open,
      close,
      destroy() {
        close();
        abort.abort();
        bracelet.destroy();
        pairPreview?.destroy();
        root.__mergedConfirm = null;
        if (NB.confirm === api) delete NB.confirm;
      }
    };
    root.__mergedConfirm = api;
    NB.confirm = api;

    on(document, 'shopify:section:unload', event => {
      if (event.target === root || event.target.contains?.(root)) api.destroy();
    });
  }

  NB.registerSection('confirm-modal', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', event => {
    const root = event.target.matches?.('[data-section-type="confirm-modal"]')
      ? event.target
      : event.target.querySelector?.('[data-section-type="confirm-modal"]');
    if (root) init(root);
  });
})();
